module.exports = __webpack_public_path__ + "img/MCD_McDrive_Fieldmap_2023_cropped.4505b0fd.jpg";